import { render, staticRenderFns } from "./RolePermissions.vue?vue&type=template&id=01a2ea36&scoped=true&"
import script from "./RolePermissions.vue?vue&type=script&lang=js&"
export * from "./RolePermissions.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissions.vue?vue&type=style&index=0&id=01a2ea36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a2ea36",
  null
  
)

export default component.exports